// DetalhesSupplier.jsx
import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Grid, 
  Typography, 
  CircularProgress, 
  List, 
  ListItem, 
  ListItemText 
} from '@mui/material';
import { getMerchandiseBySupplier } from '../../services/api';

const DetalhesSupplier = ({ open, onClose, supplier }) => {
  const [articles, setArticles] = useState([]);
  const [loadingArticles, setLoadingArticles] = useState(false);

  useEffect(() => {
    if (open && supplier) {
      const fetchArticles = async () => {
        setLoadingArticles(true);
        try {
          // Supondo que getMerchandiseBySupplier aceite o supplier.id como parâmetro
          const response = await getMerchandiseBySupplier(supplier.id);
          setArticles(response.data);
        } catch (error) {
          console.error("Erro ao carregar artigos do fornecedor:", error);
        }
        setLoadingArticles(false);
      };
      fetchArticles();
    }
  }, [open, supplier]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Detalhes do Fornecedor</DialogTitle>
      <DialogContent dividers>
        {supplier ? (
          <>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Nome:</Typography>
                <Typography variant="body2">{supplier.name}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Tipo:</Typography>
                <Typography variant="body2">{supplier.type}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Email:</Typography>
                <Typography variant="body2">{supplier.email}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Telefone:</Typography>
                <Typography variant="body2">{supplier.phone}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Endereço:</Typography>
                <Typography variant="body2">{supplier.address}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Website:</Typography>
                <Typography variant="body2">{supplier.website}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Contato:</Typography>
                <Typography variant="body2">{supplier.contact}</Typography>
              </Grid>
            </Grid>
            <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>Artigos</Typography>
            {loadingArticles ? (
              <CircularProgress size={24} />
            ) : (
              <>
                {articles.length > 0 ? (
                  <List>
                    {articles.map(article => (
                      <ListItem key={article.id} divider>
                        <ListItemText 
                          primary={article.name} 
                          secondary={`Referência: ${article.reference}`} 
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2">Nenhum artigo encontrado para este fornecedor.</Typography>
                )}
              </>
            )}
          </>
        ) : (
          <Typography variant="body2">Nenhum fornecedor selecionado.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalhesSupplier;
